import {
  YoutubeChannelVideosQuery,
  YoutubeChannelVideosResult,
  YoutubePlaylistVideosQuery,
  YoutubePlaylistVideosResult,
  YoutubeSearchQuery,
  YoutubeSearchResult,
  YoutubeVideo
} from 'shared/interfaces/Youtube';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const resourceBaseEndpoint = '/youtube';

export const YoutubeService = {
  search: async (search: YoutubeSearchQuery): Promise<YoutubeSearchResult> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${resourceBaseEndpoint}/search`,
      params: search
    });

    return response.data;
  },
  getChannelVideos: async (channelVideos: YoutubeChannelVideosQuery): Promise<YoutubeChannelVideosResult> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${resourceBaseEndpoint}/channel-videos`,
      params: channelVideos
    });

    return response.data;
  },
  getPlaylistVideos: async (playlistVideos: YoutubePlaylistVideosQuery): Promise<YoutubePlaylistVideosResult> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${resourceBaseEndpoint}/playlist-videos`,
      params: playlistVideos
    });

    return response.data;
  },
  getVideoById: async (videoId: string): Promise<YoutubeVideo> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${resourceBaseEndpoint}/video/${videoId}`
    });

    return response.data;
  },

  getVideosByIds: async (videoIds: string[]): Promise<YoutubeVideo[]> => {
    if (videoIds.length === 0) {
      return [];
    }

    const response = await axiosBaseInstance({
      method: 'get',
      url: `${resourceBaseEndpoint}/videos`,
      params: { ids: videoIds }
    });

    return response.data;
  }
};
